import { MessageCircle } from "lucide-react";
import { offer, whatsappPrefill } from "@/config/site";

export const FloatingWhatsApp = () => (
    <a
        data-testid="floating-whatsapp"
        href={whatsappPrefill(offer.genericMessage)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with Revautoz on WhatsApp"
        className="btn-sweep fixed bottom-[76px] right-4 z-40 flex items-center justify-center bg-rz-red text-white transition-colors duration-300 hover:bg-rz-reddeep md:bottom-6 md:right-6"
        style={{ height: 52, width: 52 }}
    >
        <MessageCircle size={22} strokeWidth={1.75} />
    </a>
);
